<template>
  <div class="wey-ser">
    <btHeader
      :icon-change="iconChange"
      :background-color="backgroundColor"
      :title-color="titleColor"
      title="车联续费"
      @goback="goback"
    ></btHeader>
    <div class="bgcjb" :class="[isandroid && 'mt_40']">
      <!-- title -->
      <div class="ser-tit">
        <van-skeleton
          avatar
          avatar-size="40"
          :row="2"
          :loading="user.username === ''"
        >
          <div class="ser-tit-img">
            <van-image round :src="user.avatar">
              <template #loading>
                <img :src="defaultAvatar" alt="头像" />
              </template>
              <template #error>
                <img :src="defaultAvatar" alt="头像" />
              </template>
            </van-image>
            <div class="ser-tit-p">
              <p>{{ user.username }}</p>
            </div>
          </div>
          <div class="ser-tit-right" @click="serhistory">
            <span>续费记录</span>
            <img src="../../asset/img/icon_right.png" alt="" />
          </div>
        </van-skeleton>
      </div>
      <div class="ser-card">
        <div class="brand_flex">
          <p class="series">{{ curVehicleInfo.vehicleBrandSeries }}</p>
          <div class="tabcarbtn" @click="tabcar">切换车辆</div>
        </div>
        <p class="vin">
          <span>车架号 : </span> <span>{{ curVehicleInfo.vin }}</span>
        </p>
      </div>
    </div>

    <div class="ser-tog">
      <div class="ser-tog-tit">娱乐服务畅享包</div>
      <div v-if="hasServiceList && isbd" class="service-list">
        <ul>
          <li
            v-for="(item, index) of serviceList"
            :key="index"
            :class="{ 'ser-tabactive': item.pdSkuId == chooseFwId }"
            @click="serChoose(item)"
          >
            <div>{{ item.attrName }}</div>
            <p><span>¥</span>{{ item.salePrice | yuan }}</p>
            <s>¥{{ item.price | yuan }}</s>
          </li>
        </ul>
      </div>
      <div v-else class="service-list-no">
        目前系统后台正在进行优化升级，续费通道暂时关闭，请您持续关注
      </div>
      <van-button
        v-if="hasServiceList && isbd"
        type="primary"
        block
        class="ser-nowbtn"
        :disabled="nowBtnDisabled"
        @click="picnow"
        >立即续费</van-button
      >
    </div>
    <div class="line"></div>
    <div class="detailInfo" v-html="productInfo.detailInfo"></div>
    <!-- Popup -->
    <van-popup v-model="tabcarshow" position="bottom">
      <div class="ser-tab-car">
        <p>切换车辆</p>
        <van-radio-group v-model="curVin">
          <van-radio
            v-for="(item, index) of carList"
            :key="index"
            :name="item.vin"
            label-position="left"
            @click="pickVehicle(item)"
          >
            <div class="ser-tab-car-tit ml_30">
              {{ item.vehicleBrandSeries }}
            </div>
            <div class="ser-tab-car-cjh ml_30">车架号: {{ item.vin }}</div>
            <template #icon="props">
              <img
                v-if="props.checked"
                class="select-icon"
                :src="props.checked ? selectedIcon : ''"
              />
            </template>
          </van-radio>
        </van-radio-group>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getServiceList,
  queryVehicles,
  isBaiduCar
} from "../../helper/api/service-renewal";
import { Toast } from "vant";
import defaultAvatar from "../../asset/img/default.jpg";
import { SUCCESS_CODE } from "../../utils/config";
import btHeader from "../../components/btHeader";
export default {
  components: { btHeader },
  filters: {
    yuan(val) {
      return (val / 100).toFixed(2);
    }
  },
  data() {
    return {
      defaultAvatar,
      user: {
        // 用户信息
        avatar: this.defaultAvatar,
        username: "该用户很神秘",
        phone: ""
      },
      carList: [],
      serviceList: [],
      hasServiceList: true,
      chooseFwId: "", // 选中的服务id
      chooseFwname: "", // 选中服务名称
      chooseFwpic: "", // 选中服务价格
      curVehicleInfo: {
        vehicleBrandSeries: "",
        vin: "",
        isDefault: true,
        expire: ""
      },
      tabcarshow: false, // 选择车辆弹出层
      timer: null,
      selectedIcon: require("../../asset/img/current_select.png"),
      selectedService: {},
      headers: {},
      productInfo: {},
      serviceRenewalInfo: {},
      curVin: "",
      backgroundColor: "#3e3e3e",
      titleColor: "#fff",
      iconChange: true,
      isbd: false
    };
  },
  computed: {
    nowBtnDisabled() {
      return !this.chooseFwId || !this.chooseFwname || !this.chooseFwpic;
    }
  },
  watch: {
    serviceList: {
      handler(val = []) {
        val.length && this.serChoose(val[0]);
      },
      deep: true
    },
    carList: {
      handler(val) {
        const curVin = (val || []).filter(item => item.isDefault);
        if (curVin) {
          this.curVehicleInfo = curVin[0];
          this.curVin = curVin[0].vin;
        }
      },
      deep: true
    },
    curVin(val) {
      if (!val) return;
      this._isBaiduCar(val);
      this._getServiceList(val);
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.$bridge.call("Controller.refreshNav", {
      right: [],
      fullScreen: true,
      hiddenNav: true
    });
    // 机型导航兼容
    if (window.publicMethods.appIsAndroidOrIOS() === "android") {
      this.isandroid = "mt_40";
    } else {
      this.isandroid = "";
    }
  },
  mounted() {
    window.Vue = this;
    const serviceRenewalInfo = this.$bridge.call("Storage.serviceRenewalInfo");
    if (!serviceRenewalInfo) {
      this.$toast("获取APP信息失败~~");
      return;
    }
    const {
      ssoId,
      tokenId,
      cVer,
      accessToken,
      brand,
      terminal,
      rs,
      avatar,
      username,
      phone,
      enterpriseId
    } = serviceRenewalInfo || {};
    const headers = {
      brand,
      terminal,
      accessToken,
      rs,
      enterpriseId
    };
    this.serviceRenewalInfo = serviceRenewalInfo;
    this.headers = headers;
    this.user = {
      avatar: avatar || this.defaultAvatar,
      username: username || "该用户很神秘",
      phone
    };
    this._queryVehicles({ ssoId, tokenId }, { ...headers, cVer });
  },
  beforeDestroy() {
    //  清楚定时器
    clearTimeout(this.timer);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const num = scrollTop < 0 ? 62 : 62 + scrollTop;
      this.backgroundColor = `rgb(${num}, ${num}, ${num})`;
      if (scrollTop > 50) {
        this.iconChange = false;
        this.titleColor = `rgb(${155 - scrollTop}, ${155 - scrollTop}, ${155 -
          scrollTop})`;
      } else {
        this.iconChange = true;
        this.titleColor = `rgb(${255 - scrollTop}, ${255 - scrollTop}, ${255 -
          scrollTop})`;
      }
    },
    goback() {
      this.$bridge.call("Controller.close");
    },
    // 获取绑定的车辆
    _queryVehicles(params, headers) {
      queryVehicles(params, headers).then(res => {
        const data = res.data || {};
        if (data.code === SUCCESS_CODE) this.carList = data.data || [];
        else Toast(res.data.description);
      });
    },
    // 车系互联服务的列表
    _getServiceList(vin) {
      const params = { vin };
      getServiceList(params, this.headers).then(res => {
        const data = res.data || {};
        if (data.code === SUCCESS_CODE) {
          this.productInfo = (data.data || [])[0] || {};
          this.serviceList =
            ((data.data || [])[0] || {}).mappingProductSku || [];
          this.hasServiceList = !!this.serviceList.length;
        } else {
          this.hasServiceList = false;
          Toast(res.data.description);
        }
      });
    },
    // 是否百度车机
    _isBaiduCar(vin) {
      const params = { vin };
      isBaiduCar(params, this.headers).then(res => {
        const data = res.data || {};
        if (data.code === SUCCESS_CODE) {
          this.isbd = data.data.result;
        } else {
          Toast(res.data.description);
        }
      });
    },
    serhistory() {
      this.$router.push({ path: "record-list" });
    },
    tabcar() {
      // this.selectedService = {}
      this.tabcarshow = true;
    },
    picnow() {
      const info = {
        expireTime: 30, // 订单超时时长
        vehicleVin: this.curVehicleInfo.vin, // 车架号(vin码)
        totalAmount: this.chooseFwpic, // 订单总金额
        orderItemList: [
          {
            merchantId: this.productInfo.supplierId, // 供应商id(对应商品详情supplierId)
            isBeanpay: 1, // 是否使用仙豆支付，0：使用cpsp支付，1：使用仙豆支付
            isSynCpsp: 0, // 是否同步cpsp，0：否，1：同步
            shopId: this.productInfo.storeId, // 商铺id
            productType: this.productInfo.productType, // 商品类型:1-实物商品,2-卡券商品,3,映射商品
            productCategoryId: this.productInfo.categoryId, // 商品分类id(后台分类ID)
            productId: this.selectedService.spuId, // 商品id
            productPrice: this.selectedService.salePrice, // 商品单价
            costPrice:
              this.selectedService.costPrice || this.selectedService.salePrice, // 商品成本单价（无法从商城获取成本单价的，使用商品单价）
            productQuantity: 1, // 购买数量
            productSkuId: this.selectedService.pdSkuId, // 商品sku编号
            realAmount: ~~this.selectedService.salePrice, // 该商品总价
            productName: this.selectedService.attrName, // 商品名称
            cpspOrderJson: this.curVehicleInfo.vehicleBrandSeries, // 填写车型名称
            packageId: ~~this.selectedService.servicePackageId, // 服务套餐ID
            supportReturnGoods:
              this.productInfo.supportReturnGoods === "true" ? 1 : 0, // 是否可退（是否支持退货: 0-否,1-是）
            storeId: this.productInfo.storeId, // 商品中心商铺id
            storeName: this.productInfo.storeName // 商品中心商铺名称
          }
        ]
      };
      this.$store.commit("setOrderInfo", info);
      localStorage.setItem("carWashOrder", JSON.stringify(info));
      this.$router.push({
        path: "/new-service-renewal/backlog"
      });
    },
    serChoose(e) {
      this.chooseFwId = e.pdSkuId;
      this.chooseFwname = e.attrName;
      this.chooseFwpic = e.salePrice;
      this.selectedService = e;
    },
    pickVehicle(e) {
      if (e) {
        this.curVehicleInfo = e;
      }
      this.timer = setTimeout(() => {
        this.tabcarshow = false;
      }, 300);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../asset/scss/mixin.scss";

/deep/ .van-skeleton {
  padding: 0;

  .van-skeleton__content {
    padding: 0;

    .van-skeleton__row {
      margin-top: pxTorem(8);
    }

    .van-skeleton__row:first-of-type {
      margin-top: 0;
    }
  }
}
.detailInfo {
  padding-left: pxTorem(5);
  padding-right: pxTorem(5);
  & /deep/ img {
    width: 100%;
  }
}
/deep/ .van-radio__icon {
  position: absolute;
  right: pxTorem(16);
}
/deep/ .van-radio__icon .van-icon {
  border: none;
}
/deep/ .ser-tab-car {
  padding-bottom: pxTorem(34);
  p {
    margin-top: pxTorem(20);
    text-align: center;
    color: #696d77;
  }
  .ml_30 {
    margin-left: pxTorem(15);
  }
  .select-icon {
    width: pxTorem(16);
    height: pxTorem(16);
  }
  .van-radio__icon--checked .van-icon {
    background-color: white;
    color: lime;
    border-color: rgba(0, 0, 0, 0);
  }
}
/deep/ .ser-tab-pay {
  .wxpay {
    .van-radio__icon--checked .van-icon {
      background-color: lime;
      color: white;
      border-color: rgba(0, 0, 0, 0);
    }
  }
}
.mt_40 {
  margin-top: pxTorem(30);
}
.wey-ser {
  letter-spacing: pxTorem(0.4);
  overflow: hidden;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  .ser-tabactive {
    background-color: #fff;
    border: pxTorem(1.4) solid #2d2d2d !important;
    p {
      color: #d7000f !important;
    }
  }
  .bgcjb {
    position: relative;
    padding-left: pxTorem(15);
    padding-right: pxTorem(15);
    padding-top: pxTorem(62);
    padding-bottom: pxTorem(90);
    background-color: #3e3e3e;
    .ser-tit {
      width: pxTorem(345);
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: rgba(255, 255, 255, 0.1);
      height: pxTorem(80);
      padding: pxTorem(20);
      border-radius: pxTorem(2);
      .ser-tit-img {
        flex: 1;
        display: flex;
        align-items: center;
        height: pxTorem(40);
        border-radius: 50%;
        background-size: pxTorem(40);
        .van-image {
          width: pxTorem(40);
          height: pxTorem(40);
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .ser-tit-p {
        font-size: pxTorem(16);
        margin-left: pxTorem(12);
        color: #fff;
        font-weight: 500;
        p:nth-child(1) {
          height: pxTorem(20);
          color: rgba(255, 255, 255, 1);
          font-size: pxTorem(14);
        }
        p:nth-child(2) {
          height: pxTorem(18);
          color: rgba(255, 255, 255, 0.35);
          font-size: pxTorem(12);
          margin-top: pxTorem(4);
        }
      }
      .ser-tit-right {
        display: flex;
        align-items: center;
        width: pxTorem(90);
        color: rgba(218, 177, 119, 1);
        font-size: pxTorem(12);
        font-style: normal;
        span {
          color: white;
          font-size: pxTorem(14);
          line-height: pxTorem(40);
        }
        img {
          width: pxTorem(22);
          height: pxTorem(22);
        }
      }
    }
    .ser-card {
      width: pxTorem(345);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: pxTorem(-35);
      background: url("../../asset/img/bg_series.png") no-repeat;
      background-size: 100% 100%;
      margin-top: pxTorem(20);
      padding: pxTorem(18) pxTorem(12);
      border-radius: pxTorem(2);
      border-bottom: none;
      display: flex;
      flex-direction: column;
      .brand_flex {
        display: flex;
        align-items: center;
      }
      .series {
        flex: 1;
        color: #ffffff;
        font-weight: 500;
        font-size: pxTorem(20);
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .tabcarbtn {
        border-radius: pxTorem(36);
        font-size: pxTorem(12);
        line-height: pxTorem(26);
        text-align: center;
        border: pxTorem(1) solid #fff;
        color: #fff;
        width: pxTorem(72);
        height: pxTorem(28);
      }
      .vin {
        margin-top: pxTorem(22);
        span {
          color: #fff;
          font-size: pxTorem(12);
        }
      }
    }
  }
  .ser-tog {
    padding: pxTorem(16);
    padding-top: pxTorem(60);
    overflow: hidden;
    background: #f6f6f6;
    .ser-tog-tit {
      height: pxTorem(22);
      margin-bottom: pxTorem(16);
      color: rgba(39, 44, 49, 1);
      font-size: pxTorem(16);
      font-weight: 700;
    }
    .service-list {
      width: 100%;
      min-height: pxTorem(123);
      overflow-x: scroll;
      overflow-y: hidden;
    }
    .service-list-no {
      width: 100%;
      min-height: pxTorem(123);
      text-align: center;
      line-height: pxTorem(32);
      color: rgba(39, 44, 49, 1);
      font-size: pxTorem(16);
      font-weight: 700;
      padding: 0 pxTorem(30);
    }
    ul {
      display: flex;
      font-size: 0;
      li {
        display: inline-block;
        height: pxTorem(123);
        width: pxTorem(108);
        text-align: center;
        background: #fcfcfc;
        margin: 0 pxTorem(5);
        padding: pxTorem(8) pxTorem(12);
        border-radius: pxTorem(4);
        position: relative;
        flex: 0 1 pxTorem(108);
        border: pxTorem(1.4) solid transparent;
        div {
          color: rgba(39, 44, 49, 1);
          font-size: pxTorem(14);
          font-weight: 700;
          text-align: center;
          width: pxTorem(84);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        p {
          color: rgba(39, 44, 49, 1);
          font-size: pxTorem(22);
          height: pxTorem(70);
          font-weight: 700;
          line-height: pxTorem(70);
          span {
            font-size: pxTorem(14);
          }
        }
        s {
          font-size: pxTorem(14);
          color: rgba(39, 44, 49, 0.4);
        }
      }
      li:first-of-type {
        margin-left: 0;
      }

      li:last-of-type {
        margin-right: 0;
      }
    }
    .ser-nowbtn {
      margin: pxTorem(20) 0 0 0;
      background-color: rgba(39, 44, 49, 1);
      border: 1px solid rgba(39, 44, 49, 1);
      height: pxTorem(44);
      border-radius: pxTorem(30);
      color: #fff;
      font-size: pxTorem(13);
      text-align: center;
      line-height: pxTorem(44);
    }
  }
  .line {
    width: 100%;
    height: pxTorem(8);
    background-color: rgba(245, 245, 245, 1);
  }
  .ser-tab-car {
    p {
      height: pxTorem(22);
      margin-bottom: pxTorem(16);
      color: rgba(39, 44, 49, 1);
      font-size: pxTorem(16);
      font-weight: 700;
    }
    .van-radio-group {
      .van-radio {
        height: pxTorem(72);
        padding: pxTorem(16) 0 pxTorem(13) 0;
        border-top: pxTorem(0.5) solid #eeee;
        .van-radio__label {
          .ser-tab-car-tit {
            color: rgba(39, 44, 49, 1);
            font-size: pxTorem(15);
          }
          .ser-tab-car-cjh {
            margin-top: pxTorem(4);
            color: rgba(39, 44, 49, 0.4);
            font-size: pxTorem(14);
          }
        }
      }
    }
  }
}
</style>
